import styled from 'styled-components';
import colors from 'styles/colors';
import sizes from 'styles/sizes';
import borders from 'styles/borders';
import type { DropPosition as DropPositionType } from './dragDropUtils';

/** Shared dark navy blue used for rename/add-step backgrounds across HP steps components */
export const HP_STEP_BLUE = '#102A56';

export const ICON = 'rgba(236, 236, 236, 0.64)';
export const ICON_DISABLED = '#5D6A72';
export const ICON_SIZE_PT = 17;
export const BUTTON_SECONDARY_BG = 'rgba(236, 236, 236, 0.08)';
export const BUTTON_SECONDARY_BG_DISABLED = 'rgba(236, 236, 236, 0.16)';

/** Default (and minimum) height of the step bar in px */
export const STEP_BAR_DEFAULT_HEIGHT = 48;

export const TooltipText = styled.span`
  display: block;
  font-size: ${sizes.textCaption};
  color: ${colors.black};
`;

export const KeyboardShortcutTooltipText = styled.span`
  display: block;
  font-size: ${sizes.textCaption};
  color: ${colors.gray5};
`;

// Re-export drag-drop utilities for backward compatibility
export {
  DropIndicator,
  DropPosition,
  DragOrientation,
  findClosestDragTarget,
  getChipDropPosition,
} from './dragDropUtils';

/** Shared props for step chip components (StepBarChip and StepConfigButton). */
export interface BaseStepChipProps {
  stepName: string;
  active?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  /** Validates the name during rename. Returns an error message string if invalid, or null if valid. */
  validateName?: (name: string) => Nullable<string>;
  /** Index of this chip for drag-and-drop */
  index?: number;
  /** Whether this chip is currently being dragged */
  isDragging?: boolean;
  /** Position of the drop indicator, or null if not a drop target */
  dropPosition?: DropPositionType | null;
  /** Called when drag starts on this chip */
  onDragStart?: (index: number) => void;
  /** Called when dragging over this chip with position info */
  onDragOver?: (index: number, position: 'before' | 'after') => void;
  /** Called when drag ends */
  onDragEnd?: () => void;
  /** Called when drop occurs on this chip */
  onDrop?: (index: number) => void;
}

export const TooltipContainer = styled.div`
  --tooltip-color: ${colors.gray8};
  display: none;
  position: absolute;
  bottom: 100%;
  color: ${colors.gray1};
  background-color: var(--tooltip-color);
  border-radius: ${borders.borderRadius.medium};
  padding: 8px 12px;
  text-align: center;
  white-space: nowrap;
  z-index: 1000;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    border-width: 5px;
    border-style: solid;
    border-color: var(--tooltip-color) transparent transparent transparent;
  }
`;
